import React, { useEffect, useState } from "react";
import { getWarehouses } from "../services/procurementApi";
import { getOrderPickQueue, confirmPick } from "../services/pickingApi";
import "./PickingQueuePage.css";

const PickingQueuePage = () => {
  const [warehouses, setWarehouses] = useState([]);
  const [warehouseId, setWarehouseId] = useState("");
  const [queue, setQueue] = useState([]);
  const [busySku, setBusySku] = useState(null);
  const [msg, setMsg] = useState(null);

  const loadQueue = async (wh) => {
    const items = await getOrderPickQueue(wh ? { warehouse_id: wh } : {});
    setQueue(items);
  };

  useEffect(() => {
    (async () => {
      const whs = await getWarehouses();
      setWarehouses(whs);
      const first = whs[0]?.id || "";
      setWarehouseId(first);
      loadQueue(first);
    })();
  }, []);

  const handleConfirm = async (item) => {
    setBusySku(item.sku);
    try {
      await confirmPick(item.sku);
      setMsg({ type: "success", text: `✅ ${item.sku} picked from ${item.full_code}` });
      setQueue((prev) => prev.filter((q) => q.sku !== item.sku));
    } catch (err) {
      setMsg({ type: "error", text: err.response?.data?.message || "Pick confirmation failed." });
    } finally {
      setBusySku(null);
    }
  };

  return (
    <div className="picking-page">
      <h1>Picking Queue <span className="proc-count-pill">{queue.length}</span></h1>
      <p className="subtitle" style={{ margin: "4px 0 14px" }}>
        Only items with a real order against them show up here. Confirm the pick and it comes off the
        warehouse allocation immediately.
      </p>
      <div className="proc-field" style={{ marginBottom: 14 }}>
        <select
          value={warehouseId}
          onChange={(e) => { setWarehouseId(e.target.value); loadQueue(e.target.value); }}
          style={{ padding: 10, fontSize: 15, minHeight: 44 }}
        >
          {warehouses.map((w) => <option key={w.id} value={w.id}>{w.code} — {w.name}</option>)}
        </select>
      </div>

      {msg && <div className={`proc-msg ${msg.type}`} style={{ marginBottom: 12 }}>{msg.text}</div>}

      {queue.length === 0 && <div className="pick-empty">No orders waiting to be picked right now.</div>}

      {queue.map((item) => (
        <div className="pick-card" key={item.sku}>
          {item.image_url ? (
            <img
              src={item.image_url}
              alt={item.title || item.sku}
              style={{ width: 64, height: 64, borderRadius: 10, objectFit: "cover", background: "#f1f5f9", flexShrink: 0 }}
              onError={(e) => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }}
            />
          ) : null}
          <div
            style={{
              width: 64, height: 64, borderRadius: 10, background: "#f1f5f9",
              display: item.image_url ? "none" : "flex", alignItems: "center", justifyContent: "center",
              fontSize: 11, color: "#9ca3af", flexShrink: 0,
            }}
          >
            No photo
          </div>
          <div style={{ flex: 1 }}>
            <div className="pick-location">{item.full_code}</div>
            <div className="pick-meta">
              {item.title || "Untitled"} · {item.sku}{item.price ? ` · $${Number(item.price).toFixed(2)}` : ""}
            </div>
            <div className="pick-meta" style={{ fontSize: 12, color: "#9ca3af" }}>
              Order: {item.marketplace} #{item.marketplace_order_id}
            </div>
          </div>
          <button className="pick-confirm-btn" disabled={busySku === item.sku} onClick={() => handleConfirm(item)}>
            {busySku === item.sku ? "…" : "Confirm Pick"}
          </button>
        </div>
      ))}
    </div>
  );
};

export default PickingQueuePage;
